import React, { useState } from 'react';
import { BanknotesIcon } from '@heroicons/react/24/outline';
import { Tooltip } from '../common/Tooltip';
import CreateInvoiceFromSource, { InvoiceSource, toInvoiceItems } from './CreateInvoiceFromSource';

interface Props {
  type: InvoiceSource['type'];
  /** a forrás dokumentum (order / deliveryNote / quotation / worksheet) */
  document: { id: string; number?: string; orderNumber?: string; deliveryNoteNumber?: string; quotationNumber?: string; worksheetNumber?: string; customerId?: string; items?: any[]; currency?: string; invoiceNumber?: string; invoiceType?: string };
  className?: string;
  showLabel?: boolean;
  onIssued?: (invoiceNumber?: string) => void;
}

/** „Számla” gomb bármely bizonylat sorába – a tételeket átveszi, a vevőt az ügyfélből tölti. */
const InvoiceFromDocumentButton: React.FC<Props> = ({ type, document: d, className = 'text-primary-600 hover:text-primary-700', showLabel = true, onIssued }) => {
  const [open, setOpen] = useState(false);
  const number = d.number || d.orderNumber || d.deliveryNoteNumber || d.quotationNumber || d.worksheetNumber;
  const items = toInvoiceItems(d.items || []);
  if (d.invoiceNumber) {
    return (
      <Tooltip content={`${d.invoiceType === 'PROFORMA' ? 'Díjbekérő' : 'Számla'} kiállítva: ${d.invoiceNumber}`}>
        <span className="inline-flex items-center gap-1 text-xs text-emerald-600 dark:text-emerald-400 whitespace-nowrap"><BanknotesIcon className="h-4 w-4" />{showLabel ? d.invoiceNumber : ''}</span>
      </Tooltip>
    );
  }
  const btn = (
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); if (items.length) setOpen(true); }}
      disabled={!items.length}
      className={`${className} flex items-center transition-colors ${!items.length ? 'opacity-40 cursor-not-allowed' : ''}`}
      aria-label="Számla készítése"
    >
      <BanknotesIcon className="h-4 w-4" />
      {showLabel && <span className="text-xs font-medium ml-1">Számla</span>}
    </button>
  );
  return (
    <>
      <Tooltip content={items.length ? 'Számla készítése a tételekből' : 'Nincs számlázható tétel'}>{btn}</Tooltip>
      {open && (
        <CreateInvoiceFromSource
          isOpen
          onClose={() => setOpen(false)}
          source={{ type, id: d.id, number, customerId: d.customerId, items, currency: d.currency }}
          onDone={(r) => { if (r.mode === 'issued') onIssued?.(r.invoiceNumber); }}
        />
      )}
    </>
  );
};

export default InvoiceFromDocumentButton;
